var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArchiveDownloadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.232 3.95v9.503H1.768V3.95H0v11.496h17V3.95h-1.768Z",
  fill: "#662D91"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.12 4.758V0H6.9v4.758H4.24L8.5 12.184l4.26-7.426H10.12Z",
  fill: "#662D91"
})));
export { SvgArchiveDownloadIcon as ReactComponent };
export default __webpack_public_path__ + "26e887d6ec28d026a504744b3b3a7f5a.svg";